import $, { event } from "jquery";
window.$ = $;
import 'bootstrap';
import "slick-carousel";
import "select2";
import './styles/index.scss';
import { getChartByID } from "apexcharts";



// ЛИПКИЙ HEADER ПРИ СКРОЛЕ
window.onscroll = function showHeader () {
    var header = document.querySelector('.header');

    if(window.pageYOffset > 85) {
        header.classList.add('header__fixed');
        // $('.main').classList.add('main_offset-top')
    } else {
        header.classList.remove('header__fixed');
        // $('.main').classList.remove('main_offset-top')
    }
}

// BURGER MENU
document.addEventListener('click', documentClick);

function documentClick(e) {
    const targetItem = e.target;
    if (targetItem.closest('.icon-menu')) {
        document.documentElement.classList.toggle('menu-open');
    }
}
// ------------------
const body = document.body;
const hamb = document.querySelector("#cheket");

hamb.addEventListener("click", hambHandler);

function hambHandler(e) {
  body.classList.toggle("noscroll");
}

// SHOW-MORE


const loadBtn = document.querySelector('.more');
const cardsWen = document.querySelectorAll('.card');

loadBtn.addEventListener('click', function() {
    for(let card of cardsWen) {
        card.style.display = 'flex'
    }

    loadBtn.style.display = 'none';
});

// let loadMoreBtn = document.querySelector('#load-more');
// let currentItem = 8;

// loadMoreBtn.onclick = () =>{
//     let cards = [...document.querySelectorAll('.card')];
//     for (var i =currentItem; i < currentItem + 8; i++){
//         cards[i].style.display = 'inline-block';
//     }
//     currentItem += 8;

//     if(currentItem >= cards.length){
//         loadMoreBtn.style.display = 'none';
//     }
// }


// ФИЛЬТРАЦИЯ
const buttons = document.querySelectorAll('#btn')
const cards = document.querySelectorAll('.card')
const list = document.querySelector('.filter')
// ----------- ДОБАВИТЬ/УБРАТЬ ЦВЕТ КНОПКИ
list.addEventListener('click', event => {
    const targetId = event.target.dataset.id
    const target = event.target

    if(target.classList.contains('drop__filter__button')) {
        buttons.forEach(listItem => listItem.classList.remove('active'))
        target.classList.add('active')
    }
})
// ------------------------------
    function filter (category, items) {
        items.forEach((item) => {
            const isItemFiltered = !item.classList.contains(category)
            const isShowAll = category.toLowerCase() === 'all'
            if (isItemFiltered && !isShowAll) {
                item.classList.add('anime')
            } else {
                item.classList.remove('hide')
                item.classList.remove('anime')
            }
        })
    }

    buttons.forEach((button) => {
        button.addEventListener('click', () => {
            const currentCategory = button.dataset.filter
            filter(currentCategory, cards)
        })
    })

    cards.forEach((card) => {
        card.ontransitionend = function () {
            if (card.classList.contains('anime')) {
                card.classList.add('hide')
            }
        }
    })



    function app() {
        const buttons = document.querySelectorAll('#btn')
        const cards = document.querySelectorAll('.card')
    
        function filter (category, items) {
            items.forEach((item) => {
                const isItemFiltered = !item.classList.contains(category)
                const isShowAll = category.toLowerCase() === 'all'
                if (isItemFiltered && !isShowAll) {
                    item.classList.add('anime')
                } else {
                    item.classList.remove('hide')
                    item.classList.remove('anime')
                }
            })
        }
    
        buttons.forEach((button) => {
            button.addEventListener('click', () => {
                const currentCategory = button.dataset.filter
                filter(currentCategory, cards)
            })
        })
    
        cards.forEach((card) => {
            card.ontransitionend = function () {
                if (card.classList.contains('anime')) {
                    card.classList.add('hide')
                }
            }
        })
    }
    
    app()
